import React from 'react';
import { IconCard } from '../ui/IconCard';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, HeartIcon, ClockIcon, DollarSignIcon, CalendarIcon } from 'lucide-react';
export function WhyChooseUsSection() {
  const reasons = [{
    icon: <ShieldCheckIcon className="h-8 w-8" data-id="element-324" />,
    title: 'Exceptional Safety Standards',
    description: 'All vehicles are regularly inspected and maintained to the highest safety standards.'
  }, {
    icon: <HeartIcon className="h-8 w-8" data-id="element-325" />,
    title: 'Caring & Certified Drivers',
    description: 'Our drivers are professionally trained, background-checked, and dedicated to patient care.'
  }, {
    icon: <ClockIcon className="h-8 w-8" data-id="element-326" />,
    title: 'Guaranteed On-Time Pickup',
    description: 'We understand the importance of punctuality for medical appointments.'
  }, {
    icon: <DollarSignIcon className="h-8 w-8" data-id="element-327" />,
    title: 'Honest Transparent Pricing',
    description: 'No hidden fees or surprise charges. You know exactly what you pay upfront.'
  }, {
    icon: <CalendarIcon className="h-8 w-8" data-id="element-328" />,
    title: 'Advanced Booking & Support',
    description: 'Easy online booking and 24/7 customer support for your convenience.'
  }];
  return <section className="bg-[#F5F5F5] py-20" data-id="element-329">
      <div className="max-w-7xl mx-auto px-4" data-id="element-330">
        <div className="text-center mb-12" data-id="element-331">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-332">
            Why Choose Judah Medical Transport
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-333">
            Experience the difference with our commitment to excellence in
            medical transportation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-334">
          {reasons.slice(0, 3).map((reason, index) => <IconCard key={index} {...reason} data-id="element-335" />)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12" data-id="element-336">
          {reasons.slice(3).map((reason, index) => <IconCard key={index} {...reason} data-id="element-337" />)}
        </div>

        <div className="text-center" data-id="element-338">
          <Button variant="primary" size="lg" onClick={() => document.getElementById('hero')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-339">
            Book Your Ride Now
          </Button>
        </div>
      </div>
    </section>;
}